import { render, staticRenderFns } from "./InfoLabels.vue?vue&type=template&id=6aee585e&scoped=true&"
import script from "./InfoLabels.vue?vue&type=script&lang=js&"
export * from "./InfoLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee585e",
  null
  
)

export default component.exports